import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'ereporter',
    component: Children,

    children: [
      {
        path: 'invoices',
        component: Children,

        children: [
          {
            path: '',
            name: 'invoices',
            component: () => import('../pages/Invoices/InvoicesPage')
          },
          {
            path: ':id',
            name: 'ereporter.invoice.show',
            component: () => import('../pages/Invoices/InvoicesShowPage'),
            props: route => ({
              id: Number(route.params.id)
            })
          },
          {
            path: ':id/edit',
            name: 'ereporter.invoice.edit',
            component: () => import('../pages/Invoices/InvoicesEditPage'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      },
      {
        path: 'payrolls',
        component: Children,

        children: [
          {
            path: '',
            name: 'payrolls',
            component: () => import('../pages/Payrolls/PayrollsPage')
          },
          {
            path: ':id',
            name: 'ereporter.payroll.show',
            component: () => import('../pages/Payrolls/PayrollsShowPage'),
            props: route => ({
              id: Number(route.params.id)
            })
          },
          {
            path: ':id/edit',
            name: 'ereporter.payroll.edit',
            component: () => import('../pages/Payrolls/PayrollsEditPage'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      },
      {
        path: 'expenses',
        component: Children,

        children: [
          {
            path: '',
            name: 'expenses',
            component: () => import('../pages/Expenses/ExpensesPage')
          },
          {
            path: ':id',
            name: 'ereporter.amount.show',
            component: () => import('../pages/Expenses/ExpensesShowPage'),
            props: route => ({
              id: Number(route.params.id)
            })
          },
          {
            path: ':id/edit',
            name: 'ereporter.amount.edit',
            component: () => import('../pages/Expenses/ExpensesEditPage'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      }
    ]
  }
];

export default routes;
